
export const FETCH_DOWNLOAD_DATA = 'FETCH_DOWNLOAD_DATA'
export const FETCHED_DOWNLOAD_DATA = 'FETCHED_DOWNLOAD_DATA'
export const FETCH_DOWNLOAD_DATA_WC_WI = 'FETCH_DOWNLOAD_DATA_WC_WI'
export const FETCHED_DOWNLOAD_DATA_WC_WI = 'FETCHED_DOWNLOAD_DATA_WC_WI'